<template>
    <b-modal title="সিটিজেন" hide-footer size="md"  v-model="largeModal" >
        <form @submit.prevent="addContact">
            <div class="container custom_modal_body">
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">মোবাইল নম্বর <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input type="text" @keypress="errorClear('mobile_number')"  v-validate="'required|numeric'" v-model="newContact.mobile_number" class="form-control" name="phone" placeholder="মোবাইল নম্বর">
                        <p v-show="errors.has('phone')"  style="color:red">* {{ errors.first('phone') }}</p>
                        <p style="color:red" v-if="servererrors"><span v-for="(error,key) in servererrors.mobile_number" :key="key"><span style="color:red">*{{error}}</span></span></p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">এন.আই.ডি নম্বর <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input type="text" @keypress="errorClear('nid')"  v-validate="'required|numeric'" v-model="newContact.nid" class="form-control" name="nid" placeholder="এন.আই.ডি নম্বর">
                        <p v-show="errors.has('nid')"  style="color:red">* {{ errors.first('nid') }}</p>
                        <p  v-if="servererrors"><span v-for="(error,key) in servererrors.nid" :key="key"><span style="color:red">*{{error}}</span></span></p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-4 col-form-label">নাম <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input name="Name" v-validate="'required'"   type="text"  v-model="newContact.name" class="form-control"  placeholder="নাম">
                        <p v-show="errors.has('Name')"  style="color:red">* {{ errors.first('Name') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label class="col-sm-4 col-form-label">জন্ম তারিখ</label>
                    <div class="col-sm-8">
                        <input type="date" v-model="newContact.birthday" class="form-control"  placeholder="জন্ম তারিখ">
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <input type="submit" value="Submit" v-if="!addContactLoader"  class="btn btn-primary pull-right">
                        <button v-if="! addContactLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                        <button v-if="addContactLoader" class="btn btn-primary pull-right" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Submitting...
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)

import { ADD_CONTACT,ALL_DISTRICT ,ALL_SUBDISTRICT,OPEN_CONTACT_MODAL,CLOSE_CONTACT_MODAL,ALL_USER_ROLE,UPDATE_CONTACT} from "../../store/action.type"
import { ADD_CONTACT_LOADER} from "../../store/mutation.type"
import { mapState,mapGetters } from "vuex"
export default {
    data(){
        return{
            servererrors:'',
            agent:false,
            addContactLoader:false,
            specificContacts:[],
            url:'',
            last_number:'',
            index:'',
            largeModal:false,
            newContact:{
                id:'',
                role_id:'',
                type:2,
                name: '',
                designation:'',
                geo_municipality_ward_id:'',
                geo_holding_id:'',
                geo_road_area_id:'',
                father_name:'',
                mother_name:'',
                spouse_name:'',
                area_code:'',
                mobile_number:'',
                contact_number:'',
                email: '',
                occupation:'',
                nid:'',
                birthday:'',
                district_id:'',
                subdistrict_id:'',
                ward_union:'',
                area_village:'',
                street_para:'',
                post_ofiice:'',
                company_name:'',
                agent_id:'',
                image:'',
                not_edit_image:10
            }
        }
    },
    methods:{
        imageChanged(e) {
            var fileReader = new FileReader()
            fileReader.readAsDataURL(e.target.files[0])
            fileReader.onload = (e) => {
                this.newContact.image = e.target.result
                this.newContact.not_edit_image = 11
            }
            this.url = URL.createObjectURL(e.target.files[0]);
        },
        RemoveImage: function () {
                this.newContact.image = '';
                this.newContact.not_edit_image = 10;
                this.url = '';
        },
        errorClear(fields)
        {
            delete this.servererrors[fields];
        },
        close(){
            this.largeModal = false
        },
        addContact () {
            if(this.index >= 0){
                this.updateContact();
            }
            else{
                this.$validator.validateAll().then( result =>{
                    if(result){
                        var data = this.newContact
                        this.addContactLoader = true;
                        this.$store.dispatch('ADD_CONTACT',data)
                        .then(response=>{
                            this.addContactLoader=false;
                            this.largeModal = false
                        })
                        .catch(error=>{
                            this.addContactLoader=false;
                            this.servererrors = error.response.data.errors;
                        });
                    }

                })
            }

        },
        clearInput(){
            this.newContact.type = ''
            this.newContact.agent_id = ''
            this.newContact.post_ofiice = ''
            this.newContact.company_name = ''
            this.newContact.street_para = ''
            this.newContact.ward_union = ''
            this.newContact.area_village = ''
            this.newContact.subdistrict_id = ''
            this.newContact.district_id = ''
            this.newContact.birthday = ''
            this.newContact.occupation = ''
            this.newContact.contact_number = ''
            this.newContact.mobile_number = ''
            this.newContact.area_code = ''
            this.newContact.spouse_name = ''
            this.newContact.mother_name = ''
            this.newContact.father_name = ''
            this.newContact.designation = ''
            this.newContact.name = ''
            this.newContact.email = ''
        },
        openModal(){
            this.index = -1
            this.largeModal = true
            this.newContact.name = ""
            this.newContact.nid = ""
            this.newContact.birthday = ""
            this.newContact.mobile_number = ""
            this.servererrors = ""
        },
        openEditModal(contactddd,index){
            this.largeModal = true
            this.newContact.id = contactddd.id
            this.newContact.name = contactddd.name
            this.newContact.nid = contactddd.nid
            this.newContact.birthday = contactddd.birthday
            this.newContact.mobile_number = contactddd.mobile_number
            this.index = index
            this.servererrors = ""
        },
        updateContact () {
            this.$validator.validateAll().then( result =>{
                if(result){
                    var data = this.newContact
                    var index = this.index
                    this.addContactLoader = true;
                    this.$store.dispatch('UPDATE_CONTACT',{data,index})
                    .then(response=>{
                        this.addContactLoader=false;
                        this.largeModal = false
                    })
                    .catch(error=>{
                        this.addContactLoader=false;
                        this.servererrors = error.response.data.errors;
                    });
                }

            })
        },
        getSubdistrict(){
            this.$store.dispatch('ALL_SUBDISTRICT',this.newContact.district_id)
        },
        wardLists(){
            this.$store.dispatch('WARD_LIST')
        },
        getRoadHoldings(id){
            this.$store.dispatch('HOLDING_LIST')
            this.$store.dispatch('ROAD_ADDRESS_LIST')
        },

        allDistrict(){
            this.$store.dispatch('ALL_DISTRICT')
        },
        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
        agentAdd(){
            if(this.newContact.type ==1 || this.newContact.type == 3){
                this.agent = true
                return new Promise((resolve, reject) => {
                    var type = 2
                    axios.get("api/specific/contacts/"+type)
                    .then(response => {
                        this.specificContacts = response.data
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    });
                });
            }
            else{
                this.agent = false
            }
        },
        lastNumber(){
            return new Promise((resolve, reject) => {
                axios.get("api/contacts/last-number")
                .then(response => {
                    this.last_number = response.data
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                });
            });
        }
    },
    mounted(){
        // this.allDistrict()
        // this.allRole()
        // this.lastNumber()
        // this.wardLists();
    },
    computed:{
        // ...mapGetters(["modalOperate"]),
        modalOperate: {
            get () {
                return this.$store.getters.modalOperate
            },
            set (value) {
                this.$store.commit('SET_CONTACT_MODAL', value)
            }
        }
    }

}
</script>

<style>
.custom_modal_body{
    overflow: auto;
    min-height: auto;
}
.logo_upload{
    border: 1px solid #ccc;
    width: 100%;
    height: 90px;
    background: #eceef0;
    text-align: center;
    cursor: pointer;
}
.image_upload p{
    margin-top: 10px;
    font-size: 12px;
}

.image_upload i{
    font-size: 34px;
}
.removeImage{
   position: absolute;
    right: 13px;
    top:  14px;
    color: var(--white);
    border: 1px solid;
    border-radius: 25px;
    padding: 4px 8px;
    background-color: #fb1212f5;
    font-size: 10px;
    font-family: cursive;
}
.fitimage {
    width: 32%;
    height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    background-color: #e6e6ef;
}
.required{
    color: red;
}
</style>
